import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
import holdemGameManagementSlice from './slices/holdemGameManagement.slice'
import lobbyGameManagementSlice from './slices/lobbyGameManagement.slice'
import loader from './slices/loader.slice'
import Plo4GameManagementSlice from './slices/Plo4GameManagement.slice'
import Plo5GameManagementSlice from './slices/Plo5GameManagement.slice'
import Plo6GameManagementSlice from './slices/Plo6GameManagement.slice'
import shortDeckGameManagementSlice from './slices/shortDeckGameManagement.slice'
import sngSlice from './slices/sng.slice'
import mttSlice from './slices/mtt.slice'

const rootReducer = combineReducers({
  gameSetting,
  auth: authSlice,
  loader,
  holdem: holdemGameManagementSlice,
  plo4: Plo4GameManagementSlice,
  plo5: Plo5GameManagementSlice,
  plo6: Plo6GameManagementSlice,
  shortDeck: shortDeckGameManagementSlice,
  lobby: lobbyGameManagementSlice,
  sng: sngSlice,
  mtt: mttSlice
})

export default rootReducer
